import { REQUEST_UNSUBSCRIBE, SUCCESS_UNSUBSCRIBE, FAILURE_UNSUBSCRIBE } from './constants';
import { CALL_API } from '../../middlewares/api';
import _ from 'lodash';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export function sendUnsubscribeRequest(formData) {
    if (_.isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/unsubscribe',
            body: formData,
            types: [REQUEST_UNSUBSCRIBE, SUCCESS_UNSUBSCRIBE, FAILURE_UNSUBSCRIBE]
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/unsubscribe/actions.js